<template>
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1200">
          <v-card-title>
            <v-row>
              <v-col md="6"><span>Instituições</span></v-col>
              <!-- <v-col md="4">
                <v-text-field v-model="search" append-icon="search" label="Pesquisar instituição" single-line
                  hide-details @input="filtrarInstituicao"></v-text-field>
              </v-col> -->
            </v-row>
          </v-card-title>
          <v-card style="margin: auto" width="1200">
            <v-overlay :value="isLoading">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title style="background-color: #006699; color: white"></v-card-title>
            <v-data-table :headers="headers" :items="filteredInstituicoes" class="elevation-3">
              <template v-slot:item.index="{ item }">
                <span>{{ instituicoes.indexOf(item) + 1 }}</span>
              </template>
              <template v-slot:item.enable="{ item }">
                <span>{{ item.enable == 1 ? "Activo" : "Desativada" }}</span>
              </template>
              <template v-slot:item.isintegrado="{ item }">
                <span>{{ item.isintegrado == 1 ? "Sim" : "Não" }}</span>
              </template>
              <template v-slot:item.nivel_ensino="{ item }">
                <span>{{
                  item.nivel_ensino == 1 ? "Ensino Médio" : "Ensino Superior"
                  }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-menu bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editarDados(item)"><v-icon color="#006699" small>edit</v-icon>Editar
                      dados</v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>

          <!-- ********************** EDITAR DADOS DA INSTITUIÇÃO *********************************************** -->
          <v-dialog v-if="editedItem" v-model="editarDadosInstituicao" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5"> Editar Informações </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="4" sm="4" md="4">
                      <v-text-field label="Descrição" v-model="editedItem.descricao"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <v-text-field label="Sigla" v-model="editedItem.sigla"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <v-text-field  label="Usuário permitidos" v-model="editedItem.usuarios_permitidos"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="!isAdmin">
                      <div class="tpaCombox">
                        <v-combobox v-model="integrado" label="Integrado" item-value="id" item-text="descricao"
                          :items="integrados" @change="SelecionaModulo()" return-object rounded>
                        </v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="combo_box_container">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
                          rounded transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Data de expiração da licença" readonly v-bind="attrs"
                              v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn text color="primary" @click="salvarData()">
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="!isAdmin">
                      <div class="tpaCombox">
                        <v-combobox v-model="nivelEnsino" label="Nivél de ensino" item-value="id" item-text="descricao"
                          :items="niveisEnsino" @change="SelecionaNivelEnsino()" return-object rounded>
                        </v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="estado" label="Estado" item-value="id" item-text="descricao"
                          :items="estados" @change="SelecionaEstado()" return-object rounded>
                        </v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="permissaoAlterarData" label="Alterar data" item-value="id"
                          item-text="descricao" :items="estados" @change="SelecionaActivarData()" return-object rounded>
                        </v-combobox>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                      <div class="tpaCombox">
                        <v-combobox v-model="permissaoEditarDadosEst" label="Editar Dados Estudante " item-value="id"
                          item-text="descricao" :items="estados" @change="SelecionaEditarDadosEst()" return-object rounded>
                        </v-combobox>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="fecharEditar()">
                  Fechar
                </v-btn>
                <v-btn color="green darken-1" text @click="actualizarDados()">
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
export default {
  data: () => ({
    headers: [
      { text: "#", value: "index" },
      { text: "Descrição", value: "descricao" },
      { text: "Sigla", value: "sigla" },
      { text: "Usuários Permitidos", value: "usuarios_permitidos" },
      { text: "Integrado", value: "isintegrado" },
      { text: "Licença", value: "dataExpiracao" },
      { text: "Nivél de ensino", value: "nivel_ensino" },
      { text: "Estado", value: "enable" },
      { text: "Autor", value: "autor" },
      { text: "Ações", value: "action" },
    ],
    estados: [
      { id: 1, descricao: "Activo" },
      { id: 0, descricao: "Desativada" },
    ],
    estado: null,
    permissaoAlterarData: null,
    permissaoEditarDadosEst: null,
    niveisEnsino: [
      { id: 1, descricao: "Ensino Médio" },
      { id: 2, descricao: "Ensino Superior" },
    ],
    nivelEnsino: null,
    integrados: [
      { id: 1, descricao: "Sim" },
      { id: 0, descricao: "Não" },
    ],
    integrado: null,
    utilitarios: utilitarios,
    isLoading: false,
    editedItem: {
      dataExpiracao: "",
    },
    instituicoes: [],
    editarDadosInstituicao: false,
    date: null,
    menu: false,
    search: ""
  }),

  created() {
    this.editedItem.dataExpiracao = "";
    this.date = "";
    this.getAllInstituicao();
  },
  computed: {
    dataActualLicenca() {
      return ls.get("dataActual");
    },

    i_id() {
      return ls.get("i_id")
    },

    usuario() {
      return ls.get("nomeUsuario");
    },

    isAdmin() {
      return ls.get('nivel_user') == 1;
    },
  },

  methods: {
    filtrarInstituicao() {
      if (this.search.length) {
        const searchRegex = new RegExp(this.search, 'i'); // 'i' para case-insensitive
        this.filteredInstituicoes = this.instituicoes.filter(inst =>
          searchRegex.test(inst.descricao) || searchRegex.test(inst.sigla)
        );
      } else {
        this.filteredInstituicoes = this.instituicoes;
      }
    },
    // Trazaendo todas asintituições da BD e suas onfigurações
    async getAllInstituicao() {
      this.isLoading = true;
      try {
        this.instituicoes = await axios
          .get("getAllIntituicoesInfo")
          .then((res) => res.data);

          this.instituicoes = this.instituicoes.filter((i) => i.idInstituicao ==  this.i_id)
          this.filteredInstituicoes = this.instituicoes
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao carregar os dados",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async verificarPermissaoEditarDadosEs(instituicao) {
      try {
        this.isLoading = true;
        let status = await axios.get(`/verificarHabilitarFuncao/${2}/${instituicao}`)
        .then((res) => res.data);
        if (status.length && status[0].status === 1) {
          this.permissaoEditarDadosEst = this.estados.filter(
            (e) => e.id == status[0].status
          )[0];
        } else {
          this.permissaoEditarDadosEst = this.estados.filter((e) => e.id == 0)[0];
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a validação da função editar dados estudante!",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async verificarPermissaoAlterarData(instituicao) {
      try {
        this.isLoading = true;
        let status = await axios
          .get(`/verificarHabilitarFuncao/${1}/${instituicao}`)
          .then((res) => res.data);
        if (status.length && status[0].status === 1) {
          this.permissaoAlterarData = this.estados.filter(
            (e) => e.id == status[0].status
          )[0];
        } else {
          this.permissaoAlterarData = this.estados.filter((e) => e.id == 0)[0];
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a validação da função selecionar data!",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    // Actualizando os dados da instituição
    async actualizarDados() {
      this.isLoading = true;
      this.editedItem.usuario = this.usuario;

      if (!this.date) {
        Swal.fire(
          "informação",
          "Selecione a data de expiração da licença!",
          "warning"
        );
      } else {
        this.editedItem.dataExpiracao = this.date;
        try {
          let atualizacao = await axios
            .post("/atualizarDadosInstituicao", this.editedItem)
            .then((res) => res);
          if (atualizacao.data.affectedRows >= 1 && atualizacao.status == 200) {
            if (this.editedItem.dataExpiracao > this.dataActualLicenca) {
              ls.set("licencaExpirada", 0);
            } else {
              ls.set("licencaExpirada", 1);
            }
            ls.set("dataActual", this.editedItem.dataExpiracao);
            Swal.fire(
              "Sucesso!",
              "Instituição actualizada com sucesso!",
              "success"
            );
            this.fecharEditar();
          } else {
            Swal.fire(
              "Erro",
              "Ocorreu um erro durante a actualização da instituição!",
              "error"
            );
          }
        } catch (error) {
          Swal.fire(
            "Erro",
            "Ocorreu um erro durante a actualização da instituição!",
            "error"
          );
        } finally {
          this.isLoading = false;
        }
      }
    },

    fecharEditar() {
      this.editarDadosInstituicao = false;
      this.getAllInstituicao();
    },

    SelecionaModulo() {
      this.editedItem.isintegrado = this.integrado.id;
    },

    SelecionaNivelEnsino() {
      this.editedItem.nivel_ensino = this.nivelEnsino.id;
    },

    SelecionaEstado() {
      this.editedItem.enable = this.estado.id;
    },

    SelecionaActivarData() {
      this.editedItem.editarData = this.permissaoAlterarData.id;
    },

    SelecionaEditarDadosEst() {
      this.editedItem.editarDadosEstudante = this.permissaoEditarDadosEst.id;
    },

    async editarDados(item) {
      await this.verificarPermissaoAlterarData(item.idInstituicao);
      await this.verificarPermissaoEditarDadosEs(item.idInstituicao);
      this.editarDadosInstituicao = true;
      this.editedItem = item;
      this.integrado = this.integrados.filter(
        (i) => i.id == item.isintegrado
      )[0];
      this.nivelEnsino = this.niveisEnsino.filter(
        (n) => n.id == item.nivel_ensino
      )[0];
      this.estado = this.estados.filter((e) => e.id == item.enable)[0];
      this.date = new Date(item.dataExpiracao).toISOString().substr(0, 10);
    },

    salvarData() {
      this.$refs.menu.save(this.date);
      this.editedItem.dataExpiracao = this.date;
    },
  },
};
</script>

<style scoped>
.bg {
  color: green;
  background: red;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}
</style>
